import { render } from "./job-applicants.vue?vue&type=template&id=b5c6e970"
import script from "./job-applicants.vue?vue&type=script&lang=js"
export * from "./job-applicants.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__